import { SheetFooter } from '@svenskaspelab/ui/react/sheet';
import type { PropsWithChildren, ReactNode } from 'react';

type TipsenSheetFooterProps = PropsWithChildren<{ className?: string }>;

/**
 * TipsenSheet footer wrapper.
 *
 * @param root0 root
 * @param root0.className optional class name to apply to the footer
 * @param root0.children children of the component
 * @returns TipsenSheet footer wrapper.
 */
export default function TipsenSheetFooter({ className, children }: TipsenSheetFooterProps): ReactNode {
  return <SheetFooter className={className}>{children}</SheetFooter>;
}
